export default __webpack_public_path__ + "static/media/box.2073f27f.png";